export default __webpack_public_path__ + "static/media/contact.45337377.svg";